import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgAffordability = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M45.834 24.973c1.787.176 2.99.573 3.889 1.471 1.61 1.611 1.61 4.204 1.61 9.39 0 5.185 0 7.777-1.61 9.388s-4.204 1.611-9.39 1.611h-9.166c-5.186 0-7.778 0-9.39-1.61-.897-.899-1.295-2.102-1.47-3.89"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M49.958 35.833c0-2.63-.003-4.466-.19-5.85-.18-1.346-.51-2.059-1.018-2.566-.565-.565-1.384-.912-3.05-1.076l.268-2.736c1.908.188 3.495.636 4.726 1.867 1.104 1.104 1.58 2.493 1.801 4.143.217 1.61.213 3.665.213 6.218s.004 4.608-.213 6.218c-.221 1.65-.697 3.04-1.8 4.143-1.104 1.104-2.493 1.58-4.144 1.801-1.61.217-3.664.213-6.218.213h-9.166c-2.554 0-4.608.004-6.218-.213-1.65-.222-3.04-.697-4.143-1.8-1.231-1.232-1.68-2.82-1.867-4.727l2.735-.269c.164 1.667.511 2.486 1.076 3.05.508.508 1.22.839 2.566 1.02 1.385.186 3.22.19 5.85.19h9.167c2.632 0 4.468-.004 5.853-.19 1.345-.181 2.057-.512 2.564-1.02.507-.507.838-1.218 1.019-2.563.186-1.385.19-3.221.19-5.853"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M14.667 30.333c0-5.185 0-7.778 1.61-9.389 1.612-1.61 4.204-1.61 9.39-1.61h9.166c5.186 0 7.779 0 9.39 1.61 1.61 1.611 1.61 4.204 1.61 9.39 0 5.185 0 7.777-1.61 9.388s-4.204 1.611-9.39 1.611h-9.166c-5.186 0-7.778 0-9.39-1.61-1.61-1.612-1.61-4.204-1.61-9.39"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M44.458 30.333c0-2.63-.003-4.466-.19-5.85-.18-1.346-.51-2.059-1.018-2.566-.508-.508-1.22-.838-2.566-1.019-1.384-.186-3.22-.19-5.85-.19h-9.167c-2.631 0-4.466.004-5.851.19-1.345.18-2.058.511-2.566 1.019-.507.507-.838 1.22-1.018 2.565-.187 1.385-.19 3.22-.19 5.851s.003 4.466.19 5.851c.18 1.345.51 2.058 1.018 2.566.508.507 1.22.838 2.566 1.019 1.385.186 3.22.19 5.85.19h9.167c2.632 0 4.467-.004 5.851-.19 1.346-.181 2.059-.512 2.566-1.02.507-.507.838-1.22 1.019-2.565.186-1.385.19-3.22.19-5.85m2.75 0c0 2.554.004 4.608-.213 6.218-.221 1.65-.697 3.04-1.8 4.143-1.104 1.104-2.493 1.58-4.144 1.801-1.61.217-3.664.213-6.218.213h-9.166c-2.554 0-4.608.004-6.218-.213-1.65-.222-3.04-.697-4.143-1.8-1.104-1.104-1.58-2.494-1.801-4.144-.217-1.61-.213-3.664-.213-6.218s-.004-4.607.213-6.218c.222-1.65.697-3.04 1.8-4.143s2.494-1.579 4.144-1.8c1.61-.217 3.664-.214 6.218-.214h9.166c2.554 0 4.608-.003 6.218.213 1.65.222 3.04.698 4.143 1.801 1.104 1.104 1.58 2.493 1.801 4.143.217 1.61.213 3.665.213 6.218"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M33.458 30.333a3.208 3.208 0 1 0-6.416 0 3.208 3.208 0 0 0 6.416 0m2.75 0a5.958 5.958 0 1 1-11.916 0 5.958 5.958 0 0 1 11.916 0M18.792 34v-7.333a1.375 1.375 0 0 1 2.75 0V34a1.375 1.375 0 1 1-2.75 0m20.166 0v-7.333a1.375 1.375 0 1 1 2.75 0V34a1.375 1.375 0 1 1-2.75 0"
      />
    </svg>
  );
};
export default SvgAffordability;
